import type { ReactNode } from 'react'

export type ChipVariant = 'mint' | 'red' | 'gold' | 'neutral'

interface ChipProps {
  variant?: ChipVariant
  children: ReactNode
  className?: string
}

const VARIANT_CLASSES: Record<ChipVariant, string> = {
  mint: 'bg-mint/20 text-mint',
  red: 'bg-red/20 text-red',
  gold: 'bg-gold/25 text-gold',
  neutral: 'bg-text-2/15 text-text'
}

function Chip({ variant = 'neutral', children, className = '' }: ChipProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[0.8em] font-semibold ${VARIANT_CLASSES[variant]} ${className}`}
    >
      {children}
    </span>
  )
}

export default Chip
